// removed by extract-text-webpack-plugin
module.exports = {"headerItem":"corner-header__headerItem-1CRaQ scrollable__headerItem-12O8r","actionsPanel":"corner-header__actionsPanel-1HFds","transpose":"corner-header__transpose-3ZS1r"};


//////////////////
// WEBPACK FOOTER
// ./components/account/statistic/scrollable/corner-header/corner-header.css
// module id = 778
// module chunks = 0